const styleMap = [
	// Show all text labels
	{
		elementType: 'labels.text',
		stylers: [{visibility: 'on'}],
	},
	// Simplify some administrative boundaries
	{
		featureType: 'administrative',
		elementType: 'geometry.stroke',
		stylers: [{visibility: 'on'}, {color: '#c0c0c0'}],
	},
	// Natural landscape
	{
		featureType: 'landscape.natural',
		elementType: 'geometry.fill',
		stylers: [{color: '#e0e4dd'}],
	},
	// Man-made landscape
	{
		featureType: 'landscape.man_made',
		elementType: 'geometry.fill',
		stylers: [{color: '#f5f5f5'}],
	},
	// Show all POIs
	{
		featureType: 'poi',
		stylers: [{visibility: 'on'}],
	},
	// Customize park areas
	{
		featureType: 'poi.park',
		elementType: 'geometry.fill',
		stylers: [{color: '#c5e1a5'}],
	},
	{
		featureType: 'poi.park',
		elementType: 'labels.text.fill',
		stylers: [{color: '#4d774e'}],
	},
	// Show medical, school, religious, government POIs
	{
		featureType: 'poi.medical',
		stylers: [{visibility: 'on'}],
	},
	{
		featureType: 'poi.school',
		stylers: [{visibility: 'on'}],
	},
	{
		featureType: 'poi.place_of_worship',
		stylers: [{visibility: 'on'}],
	},
	{
		featureType: 'poi.government',
		stylers: [{visibility: 'on'}],
	},
	// Water styling
	{
		featureType: 'water',
		elementType: 'geometry.fill',
		stylers: [{color: '#a0d3d3'}],
	},
	// Roads - local
	{
		featureType: 'road.local',
		elementType: 'geometry',
		stylers: [{color: '#ffffff'}, {visibility: 'on'}],
	},
	{
		featureType: 'road.local',
		elementType: 'labels.text.fill',
		stylers: [{color: '#666666'}],
	},
	// Roads - arterial
	{
		featureType: 'road.arterial',
		elementType: 'geometry',
		stylers: [{color: '#e6e6e6'}],
	},
	{
		featureType: 'road.arterial',
		elementType: 'labels.text.fill',
		stylers: [{color: '#333333'}],
	},
	// Roads - highway
	{
		featureType: 'road.highway',
		elementType: 'geometry.fill',
		stylers: [{color: '#f8c967'}],
	},
	{
		featureType: 'road.highway',
		elementType: 'geometry.stroke',
		stylers: [{color: '#e9bc62'}],
	},
	{
		featureType: 'road.highway',
		elementType: 'labels.text.fill',
		stylers: [{color: '#5e5e5e'}],
	},
	// Transit lines and stations
	{
		featureType: 'transit.line',
		stylers: [{visibility: 'on'}, {color: '#bcbcbc'}],
	},
	{
		featureType: 'transit.station',
		stylers: [{visibility: 'on'}],
	},
	// Show all road labels
	{
		featureType: 'road',
		elementType: 'labels',
		stylers: [{visibility: 'on'}],
	},
	// General landscape fill
	{
		featureType: 'landscape',
		elementType: 'geometry.fill',
		stylers: [{color: '#e5e8e7'}],
	},
];

export {styleMap};
